<template>
  <div class="mt-4">

    <!-- Modal -->
    <ModalForm />

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center">
      <h3><strong>Historico de variables configurables</strong></h3>
      <b-button v-if="validarPermisoComponente('empresa-editar-variables-configurables')" type="button" variant="primary" @click="() => onHandleShowModalForm('CREATE')">
          <i class="fa fa-plus" />
          <span class="ml-1">Agregar</span>
      </b-button>
    </div>

    <!-- Tabla historial -->
    <table class="table my-2">
      <thead>
        <tr>
          <th width="5%">#</th>
          <th width="15%">Idioma</th>
          <th width="25%">País</th>
          <th width="10%">Indicativo</th>
          <th width="20%">Teléfono de emergencia</th>
          <th width="10%">Estado</th>
          <th v-if="validarPermisoComponente('empresa-editar-variables-configurables')" width="10%" class="text-right">Acciones</th>
        </tr>
      </thead>
      <tbody v-if="configurableVariables.data && !!configurableVariables.data.length">
        <tr
          v-for="(item, key) in configurableVariables.data"
          :key="key"
        >
          <td>{{ item.languague.id }}</td>
          <td>{{ item.languague.lista }}</td>
          <td>{{ `${ item.country.code } - ${ item.country.name }` }}</td>
          <td><strong>{{ item.phone_code }}</strong></td>
          <td>{{ item.phone }}</td>
          <td>
            <b-badge class="px-3 py-1" v-if="!!item.is_active" variant="success">Activo</b-badge>
            <b-badge class="px-3 py-1" v-else variant="danger">Inactivo</b-badge>
          </td>
          <td v-if="validarPermisoComponente('empresa-editar-variables-configurables')">
            <!-- Acciones -->
            <div class="d-flex justify-content-end align-items-center">

              <!-- Editar -->
              <el-tooltip effect="dark" placement="top" content="Editar" popper-class="py-1 px-2">
                <i role="button" @click="() => onHandleShowToEdit(item)" class="fa fa-edit fa-lg text-dark ml-1 cursor-pointer" />
              </el-tooltip>

              <!-- Cambiar estado -->
              <el-tooltip effect="dark" placement="top" :content="item.is_active ? 'Inactivar': 'Activar'" popper-class="py-1 px-2">
                  <i role="button" v-if="item.is_active" @click="() => onChangeStatusConfigurableVariable(item)" class="fa fa-close fa-lg text-danger ml-2 cursor-pointer" />
                  <i role="button" v-else @click="() => onChangeStatusConfigurableVariable(item)" class="fa fa-check fa-lg text-info ml-1 cursor-pointer" />
              </el-tooltip>

            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
          <tr>
              <td colspan="6" class="p-3 text-center">
                  <span> <i class="fa fa-info-circle mr-2"></i> No hay resultados para mostrar.</span>
              </td>
          </tr>
      </tbody>
    </table>

    <!-- Paginación -->
    <div class="mb-4" v-if="configurableVariables.data && !!configurableVariables.data.length" >
        <el-pagination
            v-model="filter.page"
            layout="total, sizes, prev, pager, next"
            class="float-right"
            :current-page.sync="filter.page"
            :page-size.sync="filter.per_page"
            :page-sizes="[10, 30, 50, 100]"
            :total="configurableVariables.total"
            @size-change="changePageInPagination"
            @current-change="changePageInPagination"
        />
        <br />
    </div>

  </div>
</template>

<script>

// Importaciones generales
import { mapState, mapActions, mapMutations } from 'vuex';
import Swal from 'sweetalert2';
import { validarPermisoComponente } from "@/plugins/acl";

// Componentes
import ToggleCheckComponent from '../../../../shared/toggle-classes'
import ModalForm from './ModalForm'

export default {
  name: 'historyConfigurableVariables',
  data() {
    return {
        validarPermisoComponente: validarPermisoComponente,
    }
  },
  components: { ToggleCheckComponent, ModalForm },
  computed: {
    // Estados del modulo Empresas
    ...mapState('empresa', [
      'selectedEmpresa'
    ]),
    // Estados del modulo Variables configurables
    ...mapState('configurableVariables', [
      'configurableVariables',
      'filter',
      'modalForm'
    ])
  },
  methods: {
    // Metodos del modulo Variables configurables
    ...mapActions('configurableVariables', [
      'loadConfigurableVariables',
      'updateConfigurableVariable'
    ]),
    // Mutaciones del modulo Variables configurables
    ...mapMutations('configurableVariables', [
      'setDefaultConfigurableVariable',
      'setConfigurableVariable',
      'setModalForm',
    ]),
    /**
     * Cambiar de pagina en el paginador.
     *
     * @author Fernando Claros
     */
    async changePageInPagination() {
      const payload = {
        companyId: this.selectedEmpresa.id,
        page: this.filter.page,
        status: 'ALL'
      };
      await this.loadConfigurableVariables(payload)
    },
    /**
     * Cambiar el estado de una Variable configurable
     *
     * @author Fernando Claros
     */
    async onChangeStatusConfigurableVariable(configurableVariable) {

      const payload = {
        ...configurableVariable,
        is_active: configurableVariable.is_active ? 0 : 1,
        page: this.filter.page
      }

      const action = payload.is_active == 0 ? 'inactivar' : 'activar'

      Swal.fire({
        icon: "warning",
        title: "Variables configurables",
        text: `¿Está seguro que desea ${action} la variable?`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: `Si, ${action}!`,
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.isConfirmed) await this.updateConfigurableVariable(payload);
      });

    },
    /**
     * Mostrar datos de la Variable configurable para editarla.
     *
     * @author Fernando Claros
     */
    onHandleShowToEdit(item) {
      this.setConfigurableVariable(item);
      this.onHandleShowModalForm('EDIT');
    },
    /**
     * Mostrar modal del formulario para crear/editar.
     *
     * @author Fernando Claros
     */
    onHandleShowModalForm(action = 'CREATE') {
      if(action === 'CREATE') this.setDefaultConfigurableVariable();

      const payload = {
        isOpen: true,
        action
      };
      this.setModalForm(payload);
    }
  }
};
</script>

<style scoped></style>
